import React, { useEffect, useState } from 'react';
import { SERVICE_DOMAIN } from '../../../s3-assets/ServiceDomain';

const ServiceFooter = () => {
  const [companyAddress, setCompanyAddress] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  useEffect(() => {
    const companyData = JSON.parse(localStorage.getItem('company'));

    if (companyData) {
      // Extract address
      if (companyData.address) {
        const { streetName1, streetName2, city, state, zipcode, country } = companyData.address;
        const fullAddress = `${streetName1} ${streetName2}, ${city}, ${state}, ${zipcode}, ${country}`;
        setCompanyAddress(fullAddress);
      }

      // Extract contact phone and email
      if (companyData.contactPerson) {
        setContactPhone(companyData.contactPerson.phoneNumber);
        setContactEmail(companyData.contactPerson.email);
      }
    }
  }, []);

  return (
    <footer className="bg-white dark:bg-gray-900">
      <div className="mx-auto w-full max-w-screen-xl">
        <div className="grid grid-cols-2 gap-8 px-4 py-6 lg:py-8 md:grid-cols-4">
          <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Company</h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
              <li className="mb-4">
                <a href="/about" className="hover:underline">About</a>
              </li>
              <li className="mb-4">
                <a href="/careers" className="hover:underline">Careers</a>
              </li>
              <li className="mb-4">
                <a href="/brand-center" className="hover:underline">Brand Center</a>
              </li>
              <li className="mb-4">
                <a href="/blog" className="hover:underline">Blog</a>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Help center</h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
              <li className="mb-4">
                <a href="https://discord.com" className="hover:underline">Discord Server</a>
              </li>
              <li className="mb-4">
                <a href="https://twitter.com" className="hover:underline">Twitter</a>
              </li>
              <li className="mb-4">
                <a href="https://facebook.com" className="hover:underline">Facebook</a>
              </li>
              <li className="mb-4">
                <a href="/contact-us" className="hover:underline">Contact Us</a>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Legal</h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
              <li className="mb-4">
                <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
              </li>
              <li className="mb-4">
                <a href="/licensing" className="hover:underline">Licensing</a>
              </li>
              <li className="mb-4">
                <a href="/terms-and-conditions" className="hover:underline">Terms &amp; Conditions</a>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Contact Us</h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
              <li className="mb-4">
                <a href={`mailto:${contactEmail}`} className="hover:underline">{contactEmail || "Not available"}</a>
              </li>
              <li className="mb-4">
                <a href={`tel:${contactPhone}`} className="hover:underline">{contactPhone || "Not available"}</a>
              </li>
              <li className="mb-4">
                <span className="hover:underline">{companyAddress || "Not available"}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="px-4 py-6 bg-gray-100 dark:bg-gray-700 md:flex md:items-center md:justify-between">
          <span className="text-sm text-gray-500 dark:text-gray-300 sm:text-center">
            © {new Date().getFullYear()} Aari Works. All rights reserved.
          </span>
          <p className="text-center text-gray-600 mt-1">
            <strong>Powered by</strong>{" "}
            <img
              loading="lazy"
              src={SERVICE_DOMAIN.IMAGE_3}
              alt="Krumago"
              className="max-h-6 inline-block align-middle ml-1 cursor-pointer"
            />
            <br />
            <a
              href="https://www.krumago.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              www.krumago.com
            </a>
          </p>

          <div className="flex mt-4 sm:justify-center md:mt-0 space-x-5 rtl:space-x-reverse">
            <a href="https://www.facebook.com" className="text-gray-400 hover:text-gray-900 dark:hover:text-white">
              <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 8 19">
                <path fillRule="evenodd" d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z" clipRule="evenodd"/>
              </svg>
              <span className="sr-only">Facebook page</span>
            </a>
            <a href="https://discord.com" className="text-gray-400 hover:text-gray-900 dark:hover:text-white">
              <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 21 16">
                <path d="M16.942 1.556a16.3 16.3 0 0 0-4.126-1.3 12.04 12.04 0 0 0-.529 1.1 15.175 15.175 0 0 0-4.573 0 11.585 11.585 0 0 0-.535-1.1 16.274 16.274 0 0 0-4.129 1.3A17.392 17.392 0 0 0 .182 13.218a15.785 15.785 0 0 0 4.963 2.521c.41-.564.773-1.16 1.084-1.785a10.63 10.63 0 0 1-1.706-.83c.143-.106.283-.217.418-.33a11.664 11.664 0 0 0 10.118 0c.137.113.277.224.418.33-.544.328-1.116.606-1.71.832a12.52 12.52 0 0 0 1.084 1.785 16.46 16.46 0 0 0 5.064-2.595 17.286 17.286 0 0 0-2.973-11.59ZM6.678 10.813a1.941 1.941 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.919 1.919 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Zm6.644 0a1.94 1.94 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.918 1.918 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Z"/>
              </svg>
              <span className="sr-only">Discord community</span>
            </a>
            <a href="https://twitter.com" className="text-gray-400 hover:text-gray-900 dark:hover:text-white">
              <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 17">
                <path fillRule="evenodd" d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.08 4.08 0 0 1-1.083.137c-.264 0-.52-.026-.774-.074.526 1.666 2.064 2.879 3.94 2.91a8.21 8.21 0 0 1-4.93 1.699c-.32 0-.636-.016-.947-.048 2.005 1.29 4.29 2.041 6.809 2.041 8.168 0 12.67-6.787 12.67-12.67 0-.191-.004-.38-.013-.568a8.326 8.326 0 0 0 2.043-2.14Z" clipRule="evenodd"/>
              </svg>
              <span className="sr-only">Twitter page</span>
            </a>
            <a href="https://github.com" className="text-gray-400 hover:text-gray-900 dark:hover:text-white">
              <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M15 12.7v1.646a3 3 0 1 0-3 2.1 5.486 5.486 0 0 1-1.555-.75A4.48 4.48 0 0 0 13.11 13c.058-.12.11-.24.155-.357a5.468 5.468 0 0 1-3.574-.65A5.57 5.57 0 0 1 7.18 8.318a5.453 5.453 0 0 1-.34-2.334 5.49 5.49 0 0 1 2.41-.75c.81 0 1.608-.07 2.389-.21A5.472 5.472 0 0 1 16 9a5.453 5.453 0 0 1-1 3.7Z" clipRule="evenodd"/>
              </svg>
              <span className="sr-only">GitHub</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ServiceFooter;